export const CREATE_ADVENTURE_BONUS = 'CREATE_ADVENTURE_BONUS'
export const UPDATE_ADVENTURE_BONUS = 'UPDATE_ADVENTURE_BONUS'
export const DELETE_ADVENTURE_BONUS = 'DELETE_ADVENTURE_BONUS'